import axios from "axios";
import urls from "./URLConstant";
import { getAuthToken } from "./authToken";

const baseURL = urls.url || "/api";

export const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: false,
});

api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Centralized error handling/logging can go here
    return Promise.reject(error);
  }
);

export const httpGet = (url, config) => api.get(url, config);
export const httpPost = (url, data, config) => api.post(url, data, config);
export const httpPut = (url, data, config) => api.put(url, data, config);
export const httpPatch = (url, data, config) => api.patch(url, data, config);
export const httpDelete = (url, config) => api.delete(url, config);

export default api;


